module.exports = __webpack_public_path__ + "public/img/ztcm.edcc5ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/ztcm.png
// module id = zlfb
// module chunks = 1